export enum CartStep {
  TestsAvailable,
  ShoppingCart,
  PanelDetails,
  Consent,
  Unknown,
}
